export default {
  items: [
  {
    name: 'Dashboard',
    url: '/admin',
    icon: 'fa fa-dashboard',
    badge: {
      // variant: 'primary',
      // text: 'NEW'
    }
  },
  {
    name: 'Campaign',
    url: '/campaign',
    icon: 'fa fa-bullhorn',
    children: [
    {
      name: 'Campaign List',
      url: '/admin/campaign',
      icon: 'fa fa-bullhorn'
    },
    ]
  },
  {
    name: 'Marketing Event',
    url: '/event-manager',
    icon: 'fa fa-calendar',
    children: [
    {
      name: 'Event List',
      url: '/admin/event-manager',
      icon: 'fa fa-calendar'
    },
    ]
  },
  {
    name: 'Contact Manager',
    url: '/contact-manager',
    icon: 'fa fa-address-book',
    children: [
    {
      name: 'Contact List',
      url: '/admin/contact-manager',
      icon: 'fa fa-address-book'
    },
    {
      name: 'Contact Trash',
      url: '/admin/contact-manager/trash',
      icon: 'fa fa-trash'
    },
    ]
  },
  {
    name: 'Users',
    url: '/users',
    icon: 'fa fa-users',
    children: [
    {
      name: 'Users List',
      url: '/admin/users',
      icon: 'fa fa-users'
    },
    ]
  },
  {
    name: 'Roles',
    url: '/roles',
    icon: 'fa fa-user-secret',
    children: [
    {
      name: 'Roles List',
      url: '/admin/roles',
      icon: 'fa fa-user-secret'
    },
    ]
  },
  {
    name: 'Import Contact',
    url: '/import-contact',
    icon: 'fa fa-upload',
    children: [
    {
      name: 'Import Contact List',
      url: '/admin/import-contact',
      icon: 'fa fa-upload'
    },{
      name: 'Direct Mass Import',
      url: '/admin/direct-mass-import',
      icon: 'fa fa-upload'
    },
    // {
    //   name: 'Duplicate Mass Import',
    //   url: '/admin/duplicate-mass-import',
    //   icon: 'icon-puzzle'
    // },
    ]
  },
  {
    name: 'Export Contact',
    url: '/export-contact',
    icon: 'fa fa-download',
    children: [
    {
      name: 'Export Contact List',
      url: '/admin/export-contact',
      icon: 'fa fa-download'
    },
    ]
  },
  {
    name: 'Weightages Setting',
    url: '/weightages',
    icon: 'fa fa-calculator',
    children: [
    {
      name: 'Weightages List',
      url: '/admin/weightages',
      icon: 'fa fa-calculator'
    },
    ]
  },
  {
    name: 'Duplicate Contact',
    url: '/duplicate-contact',
    icon: 'fa fa-database',
    children: [
    {
      name: 'Duplicate Contact List',
      url: '/admin/duplicate-contact',
      icon: 'fa fa-database'
    },
    ]
  },
  ]
}
